import { Grid, InputAdornment, TextField } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import React, { FC, useState } from 'react';
import { NeighborhoodLotsDropdown, FiltersButtons, FiltersLayout } from '../../../components';
import { SalesNeighborhoodDropdown } from '../../../components/dropdowns/sales-neighborhood-dropdown';
import { Close, Search } from '@mui/icons-material';

interface IFilters {
  search?: string;
  selectedNeighborhoodId: string;
  selectedLotId: string;
}

interface ITestBuildsFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  selectedLotId: string;
  setSelectedNeighborhoodId: (val: any) => void;
  setSelectedLotId: (val: any) => void;
  setSearchValue: (val: string) => void;
  searchValue: string;
  handleSearch: (data?: IFilters, clearSearch?: boolean) => void;
  selectedNeighborhoodId: string;
}

export const TestBuildsFilters: FC<ITestBuildsFilters> = ({
  isLoading,
  applyFilters,
  selectedNeighborhoodId,
  selectedLotId,
  setSelectedNeighborhoodId,
  setSelectedLotId,
  searchValue,
  setSearchValue,
  handleSearch
}) => {
  const [hasAppliedFilters, setHasAppliedFilters] = useState<boolean>(false);
  const classes = useStyles();

  return (
    <FiltersLayout>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          size="small"
          fullWidth
          variant="outlined"
          placeholder="Search..."
          name="search"
          value={searchValue}
          disabled={isLoading}
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                className={classes.searchIcon}
                onClick={() => {
                  if (searchValue.length > 0) {
                    setHasAppliedFilters(true);
                    handleSearch({
                      selectedNeighborhoodId,
                      selectedLotId
                    });
                  }
                }}
              >
                <Search />
              </InputAdornment>
            ),
            endAdornment: searchValue ? (
              <InputAdornment
                position="end"
                className={classes.searchIcon}
                onClick={() => {
                  setSearchValue('');
                  handleSearch(undefined, true);
                }}
              >
                <Close />
              </InputAdornment>
            ) : null
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' && searchValue.length > 0) {
              handleSearch();
            }
          }}
          onChange={e => {
            setSearchValue(e.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <SalesNeighborhoodDropdown
          value={selectedNeighborhoodId}
          handleChange={value => {
            setSelectedNeighborhoodId(value);
          }}
          apiParams={{ isActive: true, forAgentNewBuilds: true, hasTestBuilds: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <NeighborhoodLotsDropdown
          value={selectedLotId}
          isDisabled={!selectedNeighborhoodId}
          handleChange={value => setSelectedLotId(value)}
          apiParams={{ neighborhoodId: selectedNeighborhoodId, hasTestBuilds: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedNeighborhoodId('');
            setSelectedLotId('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  searchIcon: {
    cursor: 'pointer',
    color: theme.palette.grey[500]
  }
}));
